import React from "react";
import { forwardRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import FilterContext from "../../../routes/FilterContext";
import {
  BodyAsFormData,
  collapsableTableData,
} from "../../../services/utilities/util";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import { connect } from "react-redux";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { downloadPdf } from "../../../services/utilities/util";
import { Modal } from "react-bootstrap";
import { JsonToExcel } from "react-json-to-excel";
import { convertJsonForExcel } from "../../../services/utilities/util";
import SearchDateBox from "../../SearchDateBox";
import MaterialTable from "material-table";
// import { Icon } from "@mui/material";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
function mapStateToProps(state) {
  return {
    filters: state.selectedFilters,
    downloadOption: state.downloadOptions,
  };
}
const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
class BusinessTrends extends React.Component {
  static contextType = FilterContext;

  state = {
    columnHeaders: [],
    majorRecentLeaseTransactions: [],
    filters: "",
    isOpenErrorDisplayModal: false,
    jsonForExcel: [],
    start_date: "",
    end_date: "",
    which_date: "",
    which_date_name: "",
    type: "supply",
    mode: "yearly",
    modeText: "Switch To Quarterly",
    gradeText: "Switch To All Grade",
    grade: "AA+",
    area: "chargeable_area", //carpetarea
    areaText: "Switch To Carpet Area",
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post("api/edge/office/get_business_trends", BodyAsFormData(filters))
      .then((res) => {
        let tableData = collapsableTableData(res.data);
        this.setState({
          majorRecentLeaseTransactions: tableData.data,
          columnHeaders: tableData.columns,
        });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      var body = new FormData();
      body.append("filter", JSON.stringify(this.props.filters));
      if (
        this.state.end_date.length > 0 &&
        this.state.end_date != "ull" &&
        this.state.start_date.length > 0 &&
        this.state.start_date != "ull" &&
        this.state.which_date.length > 0
      ) {
        body.append("end_date", this.state.end_date);
        body.append("start_date", this.state.start_date);
        body.append("which_date", this.state.which_date);
        body.append("type", this.state.type);
        body.append("mode", this.state.mode);
        body.append("grade", this.state.grade);
        body.append("area", this.state.area);
      } else if (typeof this.props.bodyParams != "undefined") {
        body = this.props.bodyParams;
      }
      this.setState({
        bodyParams: body,
      });
      this.setState({ filters: this.props.filters });
      this.setState({ showLoader: true, showGraph: false });
      apiMiddleware
        .post("api/edge/office/get_business_trends", body)
        .then((res) => {
          let tableData = collapsableTableData(res.data);
          this.setState({
            majorRecentLeaseTransactions: tableData.data,
            columnHeaders: tableData.columns,
          });
        });
    }
  }

  verifyUser(e) {
    if (this.props.downloadOption.edge_office_export === 0) {
      this.setState({ isOpenErrorDisplayModal: true });
      return false;
    }
  }

  closeErrorDisplayModal = () => {
    this.setState({ isOpenErrorDisplayModal: false });
  };

  openModal = () => {
    this.setState({ isOpen: true });
  };

  closeModal = () => this.setState({ isOpen: false });

  dateFilter = (dateValue) => {
    this.setState({
      start_date: dateValue.startDate,
      end_date: dateValue.endDate,
      which_date: dateValue.dateType,
      which_date_name: dateValue.dateTypeName,
      filters: "",
      isOpen: false,
    });
  };

  getModeData() {
    if (this.state.mode == "yearly") {
      this.setState({ mode: "quarterly" }, () => {
        var body = new FormData();
        body.append("filter", JSON.stringify(this.props.filters));
        body.append("mode", this.state.mode);
        body.append("grade", this.state.grade);
        body.append("area", this.state.area);
        body.append("type", this.state.type);
        if (
          this.state.end_date.length > 0 &&
          this.state.end_date != "ull" &&
          this.state.start_date.length > 0 &&
          this.state.start_date != "ull" &&
          this.state.which_date.length > 0
        ) {
          body.append("end_date", this.state.end_date);
          body.append("start_date", this.state.start_date);
          body.append("which_date", this.state.which_date);
        }
        apiMiddleware
          .post("api/edge/office/get_business_trends", body)
          .then((res) => {
            this.setState({ showLoader: false, showGraph: true });
            let tableData = collapsableTableData(res.data);
            this.setState({
              majorRecentLeaseTransactions: tableData.data,
              columnHeaders: tableData.columns,
            });
          });
      });
    } else if (this.state.mode == "quarterly") {
      this.setState({ mode: "yearly" }, () => {
        var body = new FormData();
        body.append("filter", JSON.stringify(this.props.filters));
        body.append("type", this.state.type);
        body.append("mode", this.state.mode);
        body.append("grade", this.state.grade);
        body.append("area", this.state.area);
        if (
          this.state.end_date.length > 0 &&
          this.state.end_date != "ull" &&
          this.state.start_date.length > 0 &&
          this.state.start_date != "ull" &&
          this.state.which_date.length > 0
        ) {
          body.append("end_date", this.state.end_date);
          body.append("start_date", this.state.start_date);
          body.append("which_date", this.state.which_date);
        }
        apiMiddleware
          .post("api/edge/office/get_business_trends", body)
          .then((res) => {
            this.setState({ showLoader: false, showGraph: true });
            let tableData = collapsableTableData(res.data);
            this.setState({
              majorRecentLeaseTransactions: tableData.data,
              columnHeaders: tableData.columns,
            });
          });
      });
    }

    if (this.state.modeText == "Switch To Quarterly") {
      this.setState({ modeText: "Switch To Yearly" });
    } else if (this.state.modeText == "Switch To Yearly") {
      this.setState({ modeText: "Switch To Quarterly" });
    }
  }

  getGradeWiseData() {
    if (this.state.grade == "All") {
      this.setState({ grade: "AA+" }, () => {
        var body = new FormData();
        body.append("filter", JSON.stringify(this.props.filters));
        body.append("type", this.state.type);
        body.append("mode", this.state.mode);
        body.append("grade", this.state.grade);
        body.append("area", this.state.area);
        if (
          this.state.end_date.length > 0 &&
          this.state.end_date != "ull" &&
          this.state.start_date.length > 0 &&
          this.state.start_date != "ull" &&
          this.state.which_date.length > 0
        ) {
          body.append("end_date", this.state.end_date);
          body.append("start_date", this.state.start_date);
          body.append("which_date", this.state.which_date);
        }
        apiMiddleware
          .post("api/edge/office/get_business_trends", body)
          .then((res) => {
            this.setState({ showLoader: false, showGraph: true });
            let tableData = collapsableTableData(res.data);
            this.setState({
              majorRecentLeaseTransactions: tableData.data,
              columnHeaders: tableData.columns,
            });
          });
      });
    } else if (this.state.grade == "AA+") {
      this.setState({ grade: "All" }, () => {
        var body = new FormData();
        body.append("filter", JSON.stringify(this.props.filters));
        body.append("type", this.state.type);
        body.append("mode", this.state.mode);
        body.append("grade", this.state.grade);
        body.append("area", this.state.area);
        if (
          this.state.end_date.length > 0 &&
          this.state.end_date != "ull" &&
          this.state.start_date.length > 0 &&
          this.state.start_date != "ull" &&
          this.state.which_date.length > 0
        ) {
          body.append("end_date", this.state.end_date);
          body.append("start_date", this.state.start_date);
          body.append("which_date", this.state.which_date);
        }
        apiMiddleware
          .post("api/edge/office/get_business_trends", body)
          .then((res) => {
            this.setState({ showLoader: false, showGraph: true });
            let tableData = collapsableTableData(res.data);
            this.setState({
              majorRecentLeaseTransactions: tableData.data,
              columnHeaders: tableData.columns,
            });
          });
      });
    }

    if (this.state.gradeText == "Switch To All Grade") {
      this.setState({ gradeText: "Switch To AA+" });
    } else if (this.state.gradeText == "Switch To AA+") {
      this.setState({ gradeText: "Switch To All Grade" });
    }
  }

  getAreaWiseData() {
    if (this.state.area == "carpetarea") {
      this.setState({ area: "chargeable_area" }, () => {
        var body = new FormData();
        body.append("filter", JSON.stringify(this.props.filters));
        body.append("type", this.state.type);
        body.append("mode", this.state.mode);
        body.append("grade", this.state.grade);
        body.append("area", this.state.area);
        apiMiddleware
          .post("api/edge/office/get_business_trends", body)
          .then((res) => {
            this.setState({ showLoader: false, showGraph: true });
            let tableData = collapsableTableData(res.data);
            this.setState({
              majorRecentLeaseTransactions: tableData.data,
              columnHeaders: tableData.columns,
            });
          });
      });
    } else if (this.state.area == "chargeable_area") {
      this.setState({ area: "carpetarea" }, () => {
        var body = new FormData();
        body.append("filter", JSON.stringify(this.props.filters));
        body.append("type", this.state.type);
        body.append("mode", this.state.mode);
        body.append("grade", this.state.grade);
        body.append("area", this.state.area);
        apiMiddleware
          .post("api/edge/office/get_business_trends", body)
          .then((res) => {
            this.setState({ showLoader: false, showGraph: true });
            let tableData = collapsableTableData(res.data);
            this.setState({
              majorRecentLeaseTransactions: tableData.data,
              columnHeaders: tableData.columns,
            });
          });
      });
    }

    if (this.state.areaText == "Switch To Chargeable Area") {
      this.setState({ areaText: "Switch To Carpet Area" });
    } else if (this.state.areaText == "Switch To Carpet Area") {
      this.setState({ areaText: "Switch To Chargeable Area" });
    }
  }

  getTypeData(e) {
    this.setState({ type: e.target.value }, () => {
      var body = new FormData();
      body.append("filter", JSON.stringify(this.props.filters));
      body.append("type", this.state.type);
      body.append("mode", this.state.mode);
      body.append("grade", this.state.grade);
      body.append("area", this.state.area);
      if (
        this.state.end_date.length > 0 &&
        this.state.end_date != "ull" &&
        this.state.start_date.length > 0 &&
        this.state.start_date != "ull" &&
        this.state.which_date.length > 0
      ) {
        body.append("end_date", this.state.end_date);
        body.append("start_date", this.state.start_date);
        body.append("which_date", this.state.which_date);
      }
      apiMiddleware
        .post("api/edge/office/get_business_trends", body)
        .then((res) => {
          this.setState({ showLoader: false, showGraph: true });
          let tableData = collapsableTableData(res.data);
          this.setState({
            majorRecentLeaseTransactions: tableData.data,
            columnHeaders: tableData.columns,
          });
        });
    });
  }

  render() {
    const data = {};
    data.startDate = this.state.start_date;
    data.endDate = this.state.end_date;
    data.dateType = this.state.which_date;
    data.dateTypeName = this.state.which_date_name;
    return (
      <div className="widget widgetTable">
        <div className="row">
          <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
            <p>Business Trends </p>
          </div>
          <div className="col-lg-3 text-end">
            <select
              onChange={(e) => {
                this.getTypeData(e);
              }}
              className="trendsSelect"
            >
              <option value="no_of_buildings"># of Buildings</option>
              <option value="rent_into_area">
                Business Trends(Rent * Area)
              </option>
              <option value="no_of_assets"># of Asstes</option>
            </select>
            <p className="colorBlack downloads">
              <FontAwesomeIcon icon={faEllipsisV} />
              <ul className="downloadOptions">
                {this.props.downloadOption.edge_office_export === 0 && (
                  <li
                    className="excelDownload"
                    onClick={(e) => {
                      this.verifyUser(e);
                    }}
                  >
                    Download as Excel
                  </li>
                )}
                {this.props.downloadOption.edge_office_export === 1 && (
                  <li
                    className="excelDownload"
                    onClick={(e) => {
                      let body = new FormData();
                      body.append("path", window.location.pathname);
                      body.append("action", "excel_export");
                      body.append("count", 1);
                      body.append(
                        "hash",
                        window.location.search.split("?").pop()
                      );
                      body.append("screen_sub_type", "commercial trends");
                      apiMiddleware
                        .post(process.env.REACT_APP_USER_ACTIVITY, body)
                        .then((res) => {});
                    }}
                  >
                    <JsonToExcel
                      title="Download as Excel"
                      data={this.state.majorRecentLeaseTransactions}
                      fileName="CommercialTrends"
                      btnClassName="download-table-xls-button"
                    />
                  </li>
                )}
                <li
                  className="pdfDownload"
                  onClick={(e) => {
                    downloadPdf("#commercialTrends", "CommercialTrends");
                    let body = new FormData();
                    body.append("path", window.location.pathname);
                    body.append("action", "pdf_download");
                    body.append("count", 1);
                    body.append(
                      "hash",
                      window.location.search.split("?").pop()
                    );
                    body.append("screen_sub_type", "Commercial Trends");
                    apiMiddleware
                      .post(process.env.REACT_APP_USER_ACTIVITY, body)
                      .then((res) => {});
                  }}
                >
                  Download as PDF <FontAwesomeIcon icon={faFilePdf} />
                </li>
                <li
                  className="pdfDownload"
                  onClick={(e) => {
                    this.openModal();
                  }}
                >
                  Select Date Range
                </li>
                <li
                  className="pdfDownload"
                  onClick={(e) => {
                    this.getModeData();
                  }}
                >
                  {this.state.modeText}
                </li>
                <li
                  className="pdfDownload"
                  onClick={(e) => {
                    this.getGradeWiseData();
                  }}
                >
                  {this.state.gradeText}
                </li>
                {this.state.type != "supply" && this.state.type != "stock" && (
                  <li
                    className="pdfDownload"
                    onClick={(e) => {
                      this.getAreaWiseData();
                    }}
                  >
                    {this.state.areaText}
                  </li>
                )}
              </ul>
            </p>
          </div>
          <div className="col-lg-12 mt-2 newFixedTable">
            <MaterialTable
              title=""
              data={this.state.majorRecentLeaseTransactions}
              icons={tableIcons}
              columns={this.state.columnHeaders}
              parentChildData={(row, rows) =>
                rows.find((a) => a.id === row.parentId)
              }
              options={{
                selection: false,
                search: false,
                sorting: false,
                paging: false,
                headerStyle: {
                  fontFamily: "Poppins",
                  color: "#000",
                  fontSize: "12px",
                  fontWeight: "600",
                },
              }}
            />
          </div>
          <div className="col-lg-12 chartSearchBox">
            <Modal
              show={this.state.isOpen}
              onHide={this.closeModal}
              className="columnsModal selectColumn downloadImgModal chartModal"
              size="lg"
            >
              <Modal.Body>
                <SearchDateBox
                  datechildFilter={this.dateFilter}
                  parentData={data}
                />
              </Modal.Body>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(BusinessTrends);
